/// <reference types="vite/client" />

import { LoggerConfig, LogLevel } from '@xanectech/types';

/**
 * @fileoverview Logger Configuration and Type Definitions
 *
 * Provides core logging infrastructure including log levels, entry formats,
 * configuration options, and performance timing utilities.
 *
 * @module logger/LoggerConfig
 */

/**
 * Default logger configuration
 *
 * - DEBUG level in development, WARN in production
 * - All features enabled
 * - Stores up to 1000 log entries
 * - All standard categories enabled by default
 *
 * @constant
 */
export const DEFAULT_CONFIG: LoggerConfig = {
  level: import.meta.env.VITE_DEV ? LogLevel.DEBUG : LogLevel.WARN,
  enableConsole: true,
  enableTimestamps: true,
  enableContext: true,
  maxEntries: 1000,
  categories: {
    auth: true,
    navigation: true,
    field_operations: true,
    storage: true,
    api: true,
    performance: true,
    ui: true,
    security: true,
    error: true,
  },
};
